import { useEffect } from 'react';
import { Flex, IconButton, Icon, useToast } from '@chakra-ui/react';
import FileSaver from 'file-saver';

import { useExportSectoExcelMutation } from 'core/API/sectoApi';
import { useRetailers } from 'core/redux/selectors/dataSelectors';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';
import { EXCEL_FILE_TYPE } from 'shared/const';
import icons from 'shared/icons';
import { tableToolbarStyle, iconTableStyle } from 'shared/styles';

import { LIST_FIELDS } from './const';
import { TSectoViewer } from './SectoContainer';
import useRetailerMultiSelect from 'hooks/useRetailerMultiSelect';

const SectoToolbar = ({
    table,
    toolId,
    selectedHiddenHeader,
    setSelectedRetailers,
    setSelectedHiddenHeader,
}: TSectoViewer & { toolId: number }) => {
    const { isLoading: isRetailerLoading, isError: isRetailerError } = useRetailers();
    const [exportSectoMutation, { isLoading: isExportLoading }] = useExportSectoExcelMutation();
    const toast = useToast();
    const { RetailerMultiSelect, retailerIds } = useRetailerMultiSelect();

    const { setGlobalFilter } = table;
    const ArrowDownIcon = icons.arrowDown;

    useEffect(() => {
        const newHiddenColumn = { ...selectedHiddenHeader };
        LIST_FIELDS.forEach((col) => {
            newHiddenColumn[col] = localStorage.getItem(col) === 'true';
        });
        setSelectedHiddenHeader(newHiddenColumn);
    }, [isRetailerLoading, isRetailerError]);

    useEffect(() => {
        setSelectedRetailers(retailerIds);
    }, [retailerIds]);

    const onClickDownloadSecto = async () => {
        try {
            const res = await exportSectoMutation({ toolId, retailerIds });
            if ('error' in res) throw new Error('something wrong occured when exporting users excel');

            const blob = new Blob([res.data], {
                type: EXCEL_FILE_TYPE,
            });

            const timeElapsed = Date.now();
            const today = new Date(timeElapsed);
            FileSaver.saveAs(blob, `secto_${today.toISOString()}.xlsx`);
            toast({
                title: 'succesfully exported secto excel',
                status: 'success',
                isClosable: true,
            });
        } catch (error) {
            toast({
                title: (error as Error).message,
                status: 'error',
                isClosable: true,
            });
        }
    };

    return isRetailerLoading ? null : (
        <Flex {...tableToolbarStyle} alignItems="center">
            <GlobalFilter globalFilter={table.getState().globalFilter} setGlobalFilter={setGlobalFilter} />
            <Flex mr={3}>
                <RetailerMultiSelect />
            </Flex>
            <IconButton
                {...iconTableStyle}
                isLoading={isExportLoading}
                onClick={onClickDownloadSecto}
                isDisabled={!retailerIds.length}
                aria-label="download list"
                size="sm"
                icon={<Icon as={ArrowDownIcon} />}
            />
        </Flex>
    );
};

export default SectoToolbar;
